import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { NotesComponent } from './notes.component';
import { NotesFiltersComponent } from './notes-filters/notes-filters.component';

import { NotesService } from './notes.service';
import { ListNotesService } from './list.service';

import { AngularMaterialModule } from '../angular-material.module';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StripHtmlPipe } from '../pipes/stripHTMLpipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    NotesFiltersComponent,
    ListNotesService,
    StripHtmlPipe,
    NotesService
  ],
  declarations: [
    NotesComponent,
    StripHtmlPipe,
    NotesFiltersComponent,
    StripHtmlPipe
  ],
  exports: [
    NotesComponent,
    StripHtmlPipe
  ]
})
export class NotesModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "../../assets/i18n/", ".json");
}